// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

// Every ratio is `maybe(number, true)`: Google omits a metric when it has no data for the
// domain/date, and the endpoint serializes that absence as `null`.
const maybeRatio = maybe(number, true);

export const isDeliverabilityPostmasterAppGroupIdDomainReputationResult = objectOf({
  date: string,
  domain: string,
  reputation: string,
  user_reported_spam_ratio: maybeRatio,
  spf_success_ratio: maybeRatio,
  dkim_success_ratio: maybeRatio,
  dmarc_success_ratio: maybeRatio,
  outbound_encryption_ratio: maybeRatio,
  inbound_encryption_ratio: maybeRatio,
});
